var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main", { staticClass: "page-error" }, [
    _c(
      "section",
      [
        _c("v-content-section", {
          staticClass: "page-error__head",
          attrs: { content: _vm.content, variant: "black" }
        }),
        _vm._v(" "),
        _c("v-search", {
          staticClass: "page-error__categories",
          attrs: { "search-input": false }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }